export const LINE = 'line';

export const DATE_MONTH_AND_TIME_FORMAT = {
	day: 'numeric',
	month: 'short',
	year: 'numeric',
	hour: 'numeric',
	minute: 'numeric',
	hour12: true,
} as const;
export const DAY_AND_DATE_FORMAT = {
	weekday: 'long',
	day: 'numeric',
	month: 'long',
	year: 'numeric',
} as const;
export const SHORT_DAY_AND_HOUR_FORMAT = {
	weekday: 'short',
	hour: 'numeric',
	hour12: true,
} as const;
export const DATE_AND_MONTH_FORMAT = { day: 'numeric', month: 'short' } as const;
export const DAY_AND_HOUR_FORMAT = { weekday: 'long', hour: 'numeric', hour12: true } as const;
export const FULL_SPACED_DATE_FORMAT = { day: 'numeric', month: 'long', year: 'numeric' } as const;
export const MONTH_AND_FORMAT = { month: 'long', year: 'numeric' } as const;
export const SHORT_MONTH_FORMAT = { month: 'short' } as const;
export const SPACED_DATE_FORMAT = { day: 'numeric', month: 'short', year: 'numeric' } as const;

export const ISO_DATE_FORMAT = 'yyyy-MM-dd';
export const ISO_DATE_FORMAT_DEPRECATED = 'YYYY-MM-DD';

export const SEARCH_BY = {
	hourly: 'h',
	daily: 'd',
	weekly: 'w',
	monthly: 'm',
} as const;

export const TIME_SCALES = {
	past48Hours: '1',
	past7Days: '2',
	past14Days: '3',
	past30Days: '4',
	pastQuarterByDay: '5',
	pastQuarterByWeek: '6',
	pastYearByWeek: '7',
	pastYearByMonth: '8',
	customTimeScale: 9,
	customDatesByHours: `9${SEARCH_BY.hourly}`,
	customDatesByDays: `9${SEARCH_BY.daily}`,
	customDatesByWeeks: `9${SEARCH_BY.weekly}`,
	customDatesByMonth: `9${SEARCH_BY.monthly}`,
} as const;

export const TIME_SCALE_TO_LABEL_FORMAT_MAP = {
	[TIME_SCALES.past48Hours]: SHORT_DAY_AND_HOUR_FORMAT,
	[TIME_SCALES.past7Days]: DATE_AND_MONTH_FORMAT,
	[TIME_SCALES.past14Days]: DATE_AND_MONTH_FORMAT,
	[TIME_SCALES.past30Days]: DATE_AND_MONTH_FORMAT,
	[TIME_SCALES.pastQuarterByDay]: DATE_AND_MONTH_FORMAT,
	[TIME_SCALES.pastQuarterByWeek]: DATE_AND_MONTH_FORMAT,
	[TIME_SCALES.pastYearByWeek]: FULL_SPACED_DATE_FORMAT,
	[TIME_SCALES.pastYearByMonth]: SHORT_MONTH_FORMAT,
	[TIME_SCALES.customDatesByHours]: SHORT_DAY_AND_HOUR_FORMAT,
	[TIME_SCALES.customDatesByDays]: DATE_AND_MONTH_FORMAT,
	[TIME_SCALES.customDatesByWeeks]: FULL_SPACED_DATE_FORMAT,
	[TIME_SCALES.customDatesByMonth]: SHORT_MONTH_FORMAT,
} as const;

export const TIME_SCALE_TO_ACCESS_POINT_FORMAT_MAP = {
	[TIME_SCALES.past48Hours]: DAY_AND_HOUR_FORMAT,
	[TIME_SCALES.past7Days]: DAY_AND_DATE_FORMAT,
	[TIME_SCALES.past14Days]: DAY_AND_DATE_FORMAT,
	[TIME_SCALES.past30Days]: DAY_AND_DATE_FORMAT,
	[TIME_SCALES.pastQuarterByDay]: DATE_AND_MONTH_FORMAT,
	[TIME_SCALES.pastQuarterByWeek]: FULL_SPACED_DATE_FORMAT,
	[TIME_SCALES.pastYearByWeek]: FULL_SPACED_DATE_FORMAT,
	[TIME_SCALES.pastYearByMonth]: MONTH_AND_FORMAT,
	[TIME_SCALES.customDatesByHours]: DAY_AND_HOUR_FORMAT,
	[TIME_SCALES.customDatesByDays]: DAY_AND_DATE_FORMAT,
	[TIME_SCALES.customDatesByWeeks]: FULL_SPACED_DATE_FORMAT,
	[TIME_SCALES.customDatesByMonth]: MONTH_AND_FORMAT,
} as const;

export const TIME_SCALE_TO_EXPANDED_FORMAT_MAP = {
	[TIME_SCALES.past48Hours]: DATE_MONTH_AND_TIME_FORMAT,
	[TIME_SCALES.past7Days]: SPACED_DATE_FORMAT,
	[TIME_SCALES.past14Days]: SPACED_DATE_FORMAT,
	[TIME_SCALES.past30Days]: SPACED_DATE_FORMAT,
	[TIME_SCALES.pastQuarterByDay]: DATE_AND_MONTH_FORMAT,
	[TIME_SCALES.pastQuarterByWeek]: FULL_SPACED_DATE_FORMAT,
	[TIME_SCALES.pastYearByWeek]: FULL_SPACED_DATE_FORMAT,
	[TIME_SCALES.pastYearByMonth]: MONTH_AND_FORMAT,
	[TIME_SCALES.customDatesByHours]: DATE_MONTH_AND_TIME_FORMAT,
	[TIME_SCALES.customDatesByDays]: DAY_AND_DATE_FORMAT,
	[TIME_SCALES.customDatesByWeeks]: FULL_SPACED_DATE_FORMAT,
	[TIME_SCALES.customDatesByMonth]: MONTH_AND_FORMAT,
} as const;

export const HOUR_TIME_SCALES = [TIME_SCALES.past48Hours, TIME_SCALES.customDatesByHours] as const;

export const WEEK_TIME_SCALES = [
	TIME_SCALES.pastQuarterByWeek,
	TIME_SCALES.pastYearByWeek,
	TIME_SCALES.customDatesByWeeks,
] as const;

export const MONTH_TIME_SCALES = [
	TIME_SCALES.pastYearByMonth,
	TIME_SCALES.customDatesByMonth,
] as const;
